<template>
  <div>
    <v-row>
      <v-col cols="12">
        <LoadAccountBankDetails @change="addFromAccountData" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <v-text-field
          v-model="v.accountNumber.$model"
          :errorMessages="getValidationErrorText(v.accountNumber)"
          v-mask="Mask.ACCOUNT_NUMBER"
          outlined
        >
          <template v-slot:label>Номер счета<sup>*</sup></template>
        </v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="v.corrAccountNumber.$model"
          :errorMessages="getValidationErrorText(v.corrAccountNumber)"
          v-mask="Mask.ACCOUNT_NUMBER"
          outlined
          label="Номер корреспондентского счета"
        />
      </v-col>
      <v-col cols="4">
        <DadataBankField
          v-model="v.bic.$model"
          :mask="Mask.BIC"
          :errorMessages="getValidationErrorText(v.bic)"
          outlined
          label="БИК"
          field="bic"          
          @suggest="onSelect"
          :suggestions="suggestions"
        />
      </v-col>
      <v-col cols="12">
        <DadataBankField
          v-model="v.bankName.$model"
          :errorMessages="getValidationErrorText(v.bankName)"
          outlined
          label="Наименование банка получателя"
          field="bankName"          
          @suggest="onSelect"
          :suggestions="suggestions"
        />
      </v-col>
      <v-col cols="12" class="py-0 text-small-size">
        <div>{{ Text.accountNumberHelperP1 }}</div>
        <div>{{ Text.accountNumberHelperP2 }}</div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators';

import { EMOJI, MinLength } from '@/utils/validate';
import { getValidationErrorText } from '@/utils/validate';
import LoadAccountBankDetails from '@/components/services/elements/LoadAccountBankDetails';
import { Mask } from '@/constants';
import { Text } from '@/utils/services';
import DadataBankField from '@/components/base/DadataBankField'

export const bankDetails = {
  accountNumber: '',
  corrAccountNumber: '',
  bic: '',
  bankName: '',
};

export const bankDetailsValidation = {
  accountNumber: {
    minLength: minLength(20),
  },
  corrAccountNumber: {
    required,
    minLength: minLength(20),
  },
  bic: {
    required,
    minLength: minLength(MinLength.BIC),
  },
  bankName: {
    required,
    maxLength: maxLength(255),
    EMOJI,
  },
};

export default {
  name: 'BankDetails',
  components: { LoadAccountBankDetails, DadataBankField },
  props: {
    v: {
      type: Object,
      required: true,
    },
    buttonTopShow: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    Text,
    Mask,
    getValidationErrorText,
    suggestions: [],
  }),
  methods: {
    addFromAccountData(data) {
      if (data) {
        this.v.accountNumber.$model = data.accountNumber;
        this.v.corrAccountNumber.$model = data.corrAccountNumber;
        this.v.bankName.$model = data.bankName;
        this.v.bic.$model = data.bic;
      }
    },
    onSelect: function (item) {
      this.suggestions = [item];
      this.v.corrAccountNumber.$model = item.corrAccountNumber;
      this.v.bankName.$model = item.bankName;
      this.v.bic.$model = item.bic;
    }
  },
};
</script>
